/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: Anil
 */

/******** Reducers ********/

const initialState = {
    getVoiceByID: {
        loading: false,
        data: null,
        error: null
    },
    get_allVoices: {
        loading: false,
        data: null,
        error: null
    },
    get_all_accent: {
        loading: false,
        data: null,
        error: null
    }
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // api , state to fetch voice by id
        case 'FETCH_VOICE_BY_ID_PENDING':
            return {
                ...state,
                getVoiceByID: { loading: true, data: null, error: null }
            };

        case 'FETCH_VOICE_BY_ID_FULFILLED':
            return {
                ...state,
                getVoiceByID: { loading: false, data: action.data, error: null }
            };

        case 'FETCH_VOICE_BY_ID_FAILED':
            return {
                ...state,
                getVoiceByID: { loading: false, data: null, error: action.data }
            };


        // twilio eleven lab state
        case 'getExistingVoices_pending':

            return {
                ...state,
                get_allVoices: { loading: true, data: null, error: null }
            };
        // twilio eleven lab state
        case 'getExistingVoices_fulfilled': {
            const allVoice = action.payload;

            // Extract unique accents (capitalized)
            const accentSet = new Set();
            allVoice.forEach((item) => {
                let accent = item.labels?.accent;
                if (accent) {
                    // Capitalize
                    accent = accent.charAt(0).toUpperCase() + accent.slice(1).toLowerCase();
                    accentSet.add(accent);
                }
            });

            // Convert Set to array of objects
            const allAccents = Array.from(accentSet).map((accent) => ({ accent }));

            // Add "Others" option
            allAccents.push({ accent: 'Others' });
            return {
                ...state,
                get_allVoices: { loading: false, data: allVoice, error: null },
                get_all_accent: { loading: false, data: allAccents, error: null }
            };
        }
        case 'getExistingVoices_failed':
            return {
                ...state,
                get_allVoices: { loading: false, data: null, error: action.payload }
            };

        default:
            return state;
    }
}
